import { inject as g, ref as U, computed as o, unref as t, watch as l, onMounted as F, onBeforeUnmount as M } from "vue";
import { POPPER_INJECTION_KEY as C } from "./index558.js";
import { buildPopperOptions as I, unwrapMeasurableEl as L } from "./index721.js";
import { usePopper as T } from "./index705.js";
import h from "./index722.js";
const y = 0, D = (r) => {
  const { popperInstanceRef: i, contentRef: a, triggerRef: d, role: p } = g(
    C,
    void 0
  ), f = U(), m = o(() => r.arrowOffset), v = o(() => ({
    name: "eventListeners",
    enabled: !!r.visible
  })), R = o(() => {
    var e;
    const n = t(f), P = (e = t(m)) != null ? e : y;
    return {
      name: "arrow",
      enabled: !h(n),
      options: {
        element: n,
        padding: P
      }
    };
  }), w = o(() => ({
    onFirstUpdate: () => {
      s();
    },
    ...I(r, [
      t(R),
      t(v)
    ])
  })), c = o(
    () => L(r.referenceEl) || t(d)
  ), { attributes: E, state: b, styles: O, update: s, forceUpdate: _, instanceRef: u } = T(c, a, w);
  return l(u, (e) => i.value = e, {
    flush: "sync"
  }), F(() => {
    l(
      () => {
        var e, n;
        return (n = (e = t(c)) == null ? void 0 : e.getBoundingClientRect) == null ? void 0 : n.call(e);
      },
      () => {
        s();
      }
    );
  }), M(() => {
    i.value = void 0;
  }), {
    attributes: E,
    arrowRef: f,
    contentRef: a,
    instanceRef: u,
    state: b,
    styles: O,
    role: p,
    forceUpdate: _,
    update: s
  };
};
export {
  D as usePopperContent
};
